import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDoorOpen } from "@fortawesome/free-solid-svg-icons";
import { FaHome } from "react-icons/fa";
import { BASE_URL } from "../../constants";

const ShelterRoomChart = () => {
  const [shelters, setShelters] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate (); 
  // Fetch room data from API
const fetchRoomsData = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/accommodation/available`);
    let { shelters } = response.data;

 
// AvailableRoomsCount and totalFreePlaces to each shelter
const sheltersWithCounts = shelters.map(shelter => {
  const availableRooms = shelter.availableRooms.filter(room => room.freePlaces > 0);
  const availableRoomsCount = availableRooms.length;
  const totalFreePlaces = availableRooms.reduce((sum, room) => sum + room.freePlaces, 0);

  return { ...shelter, availableRoomsCount, totalFreePlaces };
});

    // Sort by availableRoomsCount (descending) and take top 5
    const top5Shelters = sheltersWithCounts
      .sort((a, b) => b.availableRoomsCount - a.availableRoomsCount)
      .slice(0, 5);

    setShelters(top5Shelters);

  } catch (error) {
    console.error("Error fetching room data:", error);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchRoomsData();
  }, []);

  
  const iconColors = ["#4A90E2", "#5E60CE", "#007BFF", "#00A3E0", "#1E3A8A"];

  const handleViewDetails = (shelterId) => {
    navigate(`/shelters/shelterdetails/${shelterId}`);
  };
  return (
    <div className="card shadow-lg rounded" style={{ border: "none", minHeight: "420px" }}>
      <div className="card-header bg-transparent border-0 d-flex align-items-center justify-content-between">
        <h5 className="mb-0 text-dark fw-bold d-flex align-items-center title-text">
          <FontAwesomeIcon icon={faDoorOpen} className="me-2 text-primary" />
          Rooms Available in Shelters
        </h5>
      </div>
      <div className="card-body" style={{ padding: "0.5rem" }}>
  {loading ? (
    <div className="d-flex justify-content-center align-items-center">
    
    </div>
  ) : shelters.length > 0 ? (
    <div style={{ maxHeight: "380px", overflowY: "auto" }}>
      <div className="list-group">
      { shelters.map((shelter, index) => (
  <div
    key={index}
    className="d-flex justify-content-between align-items-center p-2 border-bottom"
  >
    <div
      className="d-flex align-items-center"
      style={{ cursor: "pointer" }}
      onClick={() => handleViewDetails(shelter.shelterId)}
    >
      <FaHome
        size={20}
        style={{
          color: iconColors[index % iconColors.length],
          stroke: "white",
          strokeWidth: "12px",
          filter: "drop-shadow(2px 4px 6px white)",
        }}
        className="me-2"
      />
      <span className="small-text">{shelter.shelterName}</span>
    </div>

    <div className="text-end">
      <span className="fw-bold text-dark small-text d-block">
        {shelter.availableRoomsCount} Rooms
      </span>
      <span
  className="text-muted small-text"
  style={{ fontSize: "0.8rem" }} 
>
  {shelter.totalFreePlaces} Free Places
</span>

    </div>
  </div>
))}

      </div>
    </div>
  ) : (
    <p className="text-muted text-center">No data available.</p>
  )}
</div>

    </div>
  );
};

export default ShelterRoomChart;
